package team.platforma.aicombo.theme.colors

import androidx.compose.runtime.Composable

@Composable
fun defineColors(isDark: Boolean) {
    if (isDark) {
        AppColors.define(
            surfaceColor = RawColors.Dark.surface_base,
            backgroundDisabledColor = RawColors.Dark.bg_disabled,
            base = BackgroundBase(
                default = RawColors.Dark.bg_base_default,
                hover = RawColors.Dark.bg_base_hover,
                press = RawColors.Dark.bg_base_press,
                focus = RawColors.Dark.bg_base_focus,
                loading = RawColors.Dark.bg_base_loading
            ),
            default = BackgroundDefault(
                default = RawColors.Dark.bg_default_default,
                hover = RawColors.Dark.bg_default_hover,
                press = RawColors.Dark.bg_default_press,
                focus = RawColors.Dark.bg_default_focus,
                loading = RawColors.Dark.bg_default_loading
            ),
            primary = BackgroundPrimary(
                default = RawColors.Dark.bg_primary_default,
                hover = RawColors.Dark.bg_primary_hover,
                press = RawColors.Dark.bg_primary_press,
                focus = RawColors.Dark.bg_primary_focus,
                loading = RawColors.Dark.bg_primary_loading
            ),
            primaryInvert = BackgroundPrimaryInvert(
                default = RawColors.Dark.bg_primary_invert_default,
                hover = RawColors.Dark.bg_primary_invert_hover,
                press = RawColors.Dark.bg_primary_invert_press,
                focus = RawColors.Dark.bg_primary_invert_focus,
                loading = RawColors.Dark.bg_primary_invert_loading
            ),
            success = BackgroundSuccess(
                default = RawColors.Dark.bg_success_default,
                hover = RawColors.Dark.bg_success_hover,
                press = RawColors.Dark.bg_success_press,
                focus = RawColors.Dark.bg_success_focus,
                loading = RawColors.Dark.bg_success_loading
            ),
            warning = BackgroundWarning(
                default = RawColors.Dark.bg_warning_default,
                hover = RawColors.Dark.bg_warning_hover,
                press = RawColors.Dark.bg_warning_press,
                focus = RawColors.Dark.bg_warning_focus,
                loading = RawColors.Dark.bg_warning_loading
            ),
            error = BackgroundError(
                default = RawColors.Dark.bg_error_default,
                hover = RawColors.Dark.bg_error_hover,
                press = RawColors.Dark.bg_error_press,
                focus = RawColors.Dark.bg_error_focus,
                loading = RawColors.Dark.bg_error_loading
            ),
            info = BackgroundInformation(
                default = RawColors.Dark.bg_inform_default,
                hover = RawColors.Dark.bg_inform_hover,
                press = RawColors.Dark.bg_inform_press,
                focus = RawColors.Dark.bg_inform_focus,
                loading = RawColors.Dark.bg_inform_loading
            ),
            text = TextColors(
                light = RawColors.Dark.text_light,
                base = RawColors.Dark.text_base,
                default = RawColors.Dark.text_default,
                primary = RawColors.Dark.text_primary,
                placeholder = RawColors.Dark.text_placeholder,
                caption = RawColors.Dark.text_caption,
                link = RawColors.Dark.text_link,
                visited = RawColors.Dark.text_visited,
                success = RawColors.Dark.text_success,
                info = RawColors.Dark.text_info,
                warning = RawColors.Dark.text_warning,
                error = RawColors.Dark.text_error,
                disabled = RawColors.Dark.text_disabled
            ),
            border = BorderColors(
                default = RawColors.Dark.border_default,
                primary = RawColors.Dark.border_primary,
                focus = RawColors.Dark.border_focus,
                info = RawColors.Dark.border_info,
                success = RawColors.Dark.border_success,
                warning = RawColors.Dark.border_warning,
                error = RawColors.Dark.border_error,
                disabled = RawColors.Dark.border_disabled,
                dark = RawColors.Dark.border_dark,
            )
        )
    } else {
        AppColors.define(
            surfaceColor = RawColors.Light.surface_base,
            backgroundDisabledColor = RawColors.Light.bg_disabled,
            base = BackgroundBase(
                default = RawColors.Light.bg_base_default,
                hover = RawColors.Light.bg_base_hover,
                press = RawColors.Light.bg_base_press,
                focus = RawColors.Light.bg_base_focus,
                loading = RawColors.Light.bg_base_loading
            ),
            default = BackgroundDefault(
                default = RawColors.Light.bg_default_default,
                hover = RawColors.Light.bg_default_hover,
                press = RawColors.Light.bg_default_press,
                focus = RawColors.Light.bg_default_focus,
                loading = RawColors.Light.bg_default_loading
            ),
            primary = BackgroundPrimary(
                default = RawColors.Light.bg_primary_default,
                hover = RawColors.Light.bg_primary_hover,
                press = RawColors.Light.bg_primary_press,
                focus = RawColors.Light.bg_primary_focus,
                loading = RawColors.Light.bg_primary_loading
            ),
            primaryInvert = BackgroundPrimaryInvert(
                default = RawColors.Light.bg_primary_invert_default,
                hover = RawColors.Light.bg_primary_invert_hover,
                press = RawColors.Light.bg_primary_invert_press,
                focus = RawColors.Light.bg_primary_invert_focus,
                loading = RawColors.Light.bg_primary_invert_loading
            ),
            success = BackgroundSuccess(
                default = RawColors.Light.bg_success_default,
                hover = RawColors.Light.bg_success_hover,
                press = RawColors.Light.bg_success_press,
                focus = RawColors.Light.bg_success_focus,
                loading = RawColors.Light.bg_success_loading
            ),
            warning = BackgroundWarning(
                default = RawColors.Light.bg_warning_default,
                hover = RawColors.Light.bg_warning_hover,
                press = RawColors.Light.bg_warning_press,
                focus = RawColors.Light.bg_warning_focus,
                loading = RawColors.Light.bg_warning_loading
            ),
            error = BackgroundError(
                default = RawColors.Light.bg_error_default,
                hover = RawColors.Light.bg_error_hover,
                press = RawColors.Light.bg_error_press,
                focus = RawColors.Light.bg_error_focus,
                loading = RawColors.Light.bg_error_loading
            ),
            info = BackgroundInformation(
                default = RawColors.Light.bg_inform_default,
                hover = RawColors.Light.bg_inform_hover,
                press = RawColors.Light.bg_inform_press,
                focus = RawColors.Light.bg_inform_focus,
                loading = RawColors.Light.bg_inform_loading
            ),
            text = TextColors(
                light = RawColors.Light.text_light,
                base = RawColors.Light.text_base,
                default = RawColors.Light.text_default,
                primary = RawColors.Light.text_primary,
                placeholder = RawColors.Light.text_placeholder,
                caption = RawColors.Light.text_caption,
                link = RawColors.Light.text_link,
                visited = RawColors.Light.text_visited,
                success = RawColors.Light.text_success,
                info = RawColors.Light.text_info,
                warning = RawColors.Light.text_warning,
                error = RawColors.Light.text_error,
                disabled = RawColors.Light.text_disabled
            ),
            border = BorderColors(
                default = RawColors.Light.border_default,
                primary = RawColors.Light.border_primary,
                focus = RawColors.Light.border_focus,
                info = RawColors.Light.border_info,
                success = RawColors.Light.border_success,
                warning = RawColors.Light.border_warning,
                error = RawColors.Light.border_error,
                disabled = RawColors.Light.border_disabled,
                dark = RawColors.Light.border_dark
            )
        )
    }
}